// extracted by mini-css-extract-plugin
export default {"bubbleThink":"BubbleThink__bubbleThink___lEVew","bubbleThinkHeader":"BubbleThink__bubbleThinkHeader___wqfoF","bubbleThinkContent":"BubbleThink__bubbleThinkContent___knGEh"};